import { Button } from "@mui/material";
import React from "react";
import { ModalButtonContainer, NegativeModalButton, PositiveModalButton } from "../../components/Button";
import { useModal } from "../../components/modal";
import { CustomTextField } from "../../components/TextFields";
import { Row } from "../../global/styledComponents";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { SelectInput } from "../../components/inputs/SelectInput";
import DateInput from "../../components/inputs/dateInput";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const schema = yup.object().shape({
    title: yup.string().required("عنوان الزامی است."),
    amount: yup.number().required(" مبلغ الزامی است."),
    trackingCode: yup.number().required(" کدپیگیری الزامی است."),
    date: yup.number().required(" تاریخ پرداخت الزامی است."),
    teacher: yup.number().required("  استاد الزامی است."),
    description: yup.string().required(" توضیحات الزامی است."),
});

export default function AddModal() {
    const { setShow } = useModal();
    const {
        setValue,
        formState: { errors },
        watch,
    } = useForm({
        resolver: yupResolver(schema),
    });
    return (
        <React.Fragment>
            <CustomTextField
                variant="outlined"
                placeholder="عنوان را وارد کنید."
                label="عنوان"
                required
                onChange={(e) => setValue("title", e.target.value)}
                value={watch("title")}
                error={!!errors.title}
                helperText={errors.title?.message}
            />
            <Row gap=".5rem">
                <SelectInput
                    error={!!errors.teacher}
                    helperText={errors.teacher?.message}
                    onChange={(e) => setValue("teacher", e?.value)}
                    label="استاد"
                    options={[
                        { label: "استاد1" },
                        { label: "استاد2" },
                        { label: "استاد3" },
                    ]}
                // placeholder="استاد را وارد کنید."
                // required
                // onChange={(e) => setValue("teacher", Number(e.target.value))}
                // value={watch("teacher")}
                // error={!!errors.teacher}
                // helperText={errors.teacher?.message}
                />
                <CustomTextField
                    variant="outlined"
                    placeholder="مبلغ را وارد کنید."
                    label="مبلغ"
                    required
                    onChange={(e) => setValue("amount", Number(e.target.value))}
                    value={watch("amount")}
                    error={!!errors.amount}
                    helperText={errors.amount?.message}
                />
            </Row>
            <Row gap=".5rem">
                <CustomTextField
                    variant="outlined"
                    placeholder="کدپیگیری را وارد کنید."
                    label="کدپیگیری"
                    required
                    onChange={(e) => setValue("trackingCode", Number(e.target.value))}
                    value={watch("trackingCode")}
                    error={!!errors.trackingCode}
                    helperText={errors.trackingCode?.message}
                />
                <DateInput
                    label="تاریخ پرداخت"
                    onChange={(e: any | undefined) => setValue("date", e)}
                    icon={<CalendarMonthIcon />}
                />
            </Row>
            <CustomTextField
                variant="outlined"
                placeholder="توضیحات  را وارد کنید."
                label="توضیحات "
                required
                multiline
                minRows={2}
                maxRows={4}
                onChange={(e) => setValue("description", e.target.value)}
                value={watch("description")}
                error={!!errors.description}
                helperText={errors.description?.message}
            />
            <ModalButtonContainer>
                <Button
                    style={NegativeModalButton}
                    sx={{
                        color: "divider",
                        bgcolor: "primary.main",
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderColor: "divider",
                        ":hover": {
                            bgcolor: "divider",
                            color: "primary.main"
                        },
                    }}
                    onClick={() => setShow(false)}
                >
                    انصراف
                </Button>
                <Button
                    style={PositiveModalButton}
                    sx={{
                        ":hover": {
                            bgcolor: "customColors.purple",
                            color: "secondary.main"
                        },
                    }}
                >
                    تایید
                </Button>
            </ModalButtonContainer >
        </React.Fragment>
    )
}